angular.module('impactx.ruleset').directive('ixRuleBasketValidation', function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, element, attrs) {
            var allFields = ['Contract', 'Company', 'User', 'UserGroup', 'DeliveryCompanyDiffers'];
            scope.$watch(attrs.ngModel, function (modelValue) {
                var selectedCounter = 0;
                var selectedFields = [];
                if (impactX.isDefined(modelValue, 'contract.selected')) {
                    selectedCounter++;
                    selectedFields.push(allFields[0]);
                }
                if (impactX.isDefined(modelValue, 'company.selected')) {
                    selectedCounter++;
                    selectedFields.push(allFields[1]);
                }
                if (impactX.isDefined(modelValue, 'user.selected')) {
                    selectedCounter++;
                    selectedFields.push(allFields[2]);
                }
                if (impactX.isDefined(modelValue, 'userGroup.selected')) {
                    selectedCounter++;
                    selectedFields.push(allFields[3]);
                }
                if (modelValue && modelValue.deliveryCompanyDiffers && modelValue.deliveryCompanyDiffers.value) {
                    selectedCounter++;
                    selectedFields.push(allFields[4]);
                }
                setValidityFormControls(allFields, true);
                if (selectedCounter > 1) {
                    setValidityFormControls(selectedFields, false);
                }
                else if (selectedCounter == 0) {
                    setValidityFormControls(allFields, false);
                }
            }, true);

            function setValidityFormControls(fieldNames, value) {
                angular.forEach(fieldNames, function (fieldName) {
                    var formControl = impactX.isDefined(scope, 'dialogData.condition' + fieldName);
                    if (formControl) {
                        formControl.$setValidity('oneCondition', value);
                    }
                });
            }
        }
    }
});